import { render, staticRenderFns } from "./jyList.vue?vue&type=template&id=35b1f8f3&"
import script from "./jyList.vue?vue&type=script&lang=js&"
export * from "./jyList.vue?vue&type=script&lang=js&"
import style0 from "./jyList.vue?vue&type=style&index=0&id=35b1f8f3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports